import {Injectable} from '@angular/core';
import {AbstractSaveOneService} from '../../../core/service/v2/service/save/abstractSaveOne.service';
import {MessageModel} from '../../api/model/messageModel';
import {MessageCreateWithBusinessContextPayload} from './payload/messageCreateWithBusinessContext.payload';
import {MessageRepository} from './ngrx/message.repository';
import {MessageDataServiceAdapter} from './ngrx/messageDataService.adapter';

@Injectable()
export class MessageSaveService extends AbstractSaveOneService<MessageModel, MessageCreateWithBusinessContextPayload> {

    constructor(repository: MessageRepository, dataServiceAdapter: MessageDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }

    protected buildBody(payload: MessageCreateWithBusinessContextPayload): any {
        // Create
        const formData = new FormData();
        formData.append('data', JSON.stringify(
            {
                    entityId: payload.businessContext.entityId,
                    contextName: payload.businessContext.contextName
            }));

        formData.append('messageContent', payload.message.content);
        payload.message.attachments.forEach((attachment) => formData.append('attachments', attachment.rawFile));
        return formData;
    }
}
